import { render, staticRenderFns } from "./AdScroll.vue?vue&type=template&id=51389e57&scoped=true"
import script from "./AdScroll.vue?vue&type=script&lang=js"
export * from "./AdScroll.vue?vue&type=script&lang=js"
import style0 from "./AdScroll.vue?vue&type=style&index=0&id=51389e57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51389e57",
  null
  
)

export default component.exports